import Yt from "./trigger-condition.js";
export default class Zt {
  constructor(t, i) {
    (this.du = t), (this.gu = i);
  }
  Gl(t) {
    if (null == this.du) return !1;
    const i = Yt.pu(t[0], this.du);
    if (!i) return !1;
    let r = null == this.gu || 0 === this.gu.length;
    if (null != this.gu)
      for (let i = 0; i < this.gu.length; i++)
        if (this.gu[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new Zt(t ? t.id : null, t ? t.buttons : null);
  }
  ss() {
    return this.du;
  }
}
